module.exports = Promise.all([__parcel__import__("lHepl"), __parcel__import__("2db8A")]).then(() => parcelRequire('g36Vt'));